// 1. 引入对应模块
import Vue from 'vue'
import VueRouter from 'vue-router'

const Home = () => import('./../pages/Home/Home');
const Serve = () => import('../pages/Serve/Serve');
const Contact = () => import('./../pages/Contact/Contact');
const Dcha = () => import('../pages/Dcha/Dcha');
const DchaDetail = () => import('../pages/Dcha/DchaDetail');
const DchaDetail2 = () => import('../pages/Dcha/DchaDetail2');
const DchaDetail3 = () => import('../pages/Dcha/DchaDetail3');

// 2. 声明使用
Vue.use(VueRouter);

// 3. 输出路由对象
export default new VueRouter({
  // 3.1 配置一级路由
  routes: [
    {
      path: '/home',
      component: Home,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, title: "Deep Talenting" },
    },
    {
      path: '/serve',
      component: Serve,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, title: "Deep Talenting" }
    },
    {
      path: '/dcha',
      component: Dcha,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, title: "Deep Talenting" }
    },
    {
      path: '/dcha-detail',
      component: DchaDetail,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, title: "Deep Talenting" }
    },
    {
      path: '/dcha-detail-2',
      component: DchaDetail2,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, title: "Deep Talenting" }
    },
    {
      path: '/dcha-detail-3',
      component: DchaDetail3,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, title: "Deep Talenting" }
    },
    {
      path: '/contact',
      component: Contact,
      meta: { showHeaderTop: true, showFooter: true, showChatFooter: true, title: "Deep Talenting"}
    },
    {
      path: '/',
      redirect: '/home'
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js